/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { httpInterceptorProviders } from './http-interceptors';
import { SbAudioDirective } from './directives/sb-audio.directive';
import { LottieModule } from 'ngx-lottie';
import { JwtGuard } from './jwt-guard.service';
import { UserService } from './@core/services/jwt_service';
import { LoginComponent } from './jwt/jwt.component';
import { ComponentsModule } from './components/components.module';
export function playerFactory() {
  return import('lottie-web');
}


@NgModule({
  declarations: [AppComponent, SbAudioDirective],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ComponentsModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    LottieModule.forRoot({ player: playerFactory }),
    CoreModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [httpInterceptorProviders, JwtGuard, UserService, LoginComponent],
})

export class AppModule {
}
